import React, {
    useContext
} from 'react';
import { ExpansionPanel } from '@ferris/react/components/expansion-panel';
import { TrackingContext } from '@vrbo/react-event-tracking';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { createInteractionEvent } from '../../../../utils/EventProviders/EgClickstreamUtil';

const CompetitorLink = (props) => {
    const {
        title,
        description,
        field,
        display
    } = props;
    const [expansionOpen, setExpansionOpen] = React.useState(false);

    if (!display) return null;
    const { trigger } = useContext(TrackingContext);

    const onToggle = (open) => {
        setExpansionOpen(open);
        trigger('interaction', createInteractionEvent(open ? 'card.opened' : 'card.closed',
            'Estimateresults',
            'Estimateresults'));
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setExpansionOpen(!expansionOpen);
        }
    };

    return (
        <ExpansionPanel
            title={title}
            onToggle={onToggle}
            classes={cn('competitor-link')}
            tabIndex={0}
            role="button"
            onKeyDown={handleKeyDown}
            aria-label={title}
            aria-expanded={expansionOpen}
            open={expansionOpen}
        >
            <p>{description}</p>
            {field}
        </ExpansionPanel>
    );
};

CompetitorLink.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    field: PropTypes.node.isRequired,
    display: PropTypes.bool.isRequired
};

export default CompetitorLink;
